import constants from "../../../constants";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getDataFromStorage } from "../../../util";
import useAxiosPrivate from "../../useAxiosPrivate";
import AlertContext from "../../../context/AlertContext";
import MockTestLibraryHooks from "./MockTestLibraryHooks";
import useCommonFunctionHooks from "../../useCommonFunctionHooks";
import { MockTestPageContext } from "../../../context/MockTestPageContext";

export default function CompanySpecificResultsDetails() {
  const Alert = useContext(AlertContext);
  const MockTestPageCxt = useContext(MockTestPageContext);

  const axios = useAxiosPrivate();
  const { handleSearch } = MockTestLibraryHooks();

  const { getCatchBlockDetails, getHeaderDetailsForAxios } =
    useCommonFunctionHooks();

  const { pathname } = useLocation();

  MockTestPageCxt.searchMockTest.sort(
    (date1, date2) =>
      new Date(date2.submitteddate) - new Date(date1.submitteddate)
  );

  useEffect(() => {
    handleSearch();
  }, [MockTestPageCxt.searchText]);

  useEffect(() => {
    Alert.setIsLoaded(true);
    axios
      .get(
        `node/learner/${getDataFromStorage("learnerid")}/mock/completed?name=COMPANY`,
        getHeaderDetailsForAxios()
      )
      .then((res) => {
        if (res.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
          Alert.setShowNotify({
            show: true,
            title: "Info",
            msg: res.data.message,
          });
        } else {
          const woAIQuestions = res.data.data.tests?.filter(
            (data) => !data.aiMode
          );

          if (res.data.data.hasOwnProperty("paths")) {
            MockTestPageCxt.setMockTest(
              woAIQuestions?.concat(res.data.data.paths) || res.data.data.paths
            );
            MockTestPageCxt.setSearchMockTest(
              woAIQuestions?.concat(res.data.data.paths) || res.data.data.paths
            );
          } else {
            MockTestPageCxt.setMockTest(woAIQuestions || []);
            MockTestPageCxt.setSearchMockTest(woAIQuestions || []);
          }
        }
      })
      .catch((error) => {
        getCatchBlockDetails(error);
      })
      .finally(() => {
        Alert.setIsLoaded(false);
      });
  }, [pathname, MockTestPageCxt.dataRerender]);
}
